import React, { Suspense, useContext, useEffect, useState } from "react";

// language
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import { LoadingComponent } from "./auth/components";
import i18n from "./locale/i18n";

// Router
import Router from "./utils/router/router";

// Cookies acception management
import { getAllCompletions } from "./utils/requests/completions";
import { getPipelines } from "./utils/requests/pipelines";
import { VariablesContext } from "./auth/AppProvider";
import Splasher from "./components/loading/Splasher";
import PlateformeComingSoon from "./pages/PlateformeComingSoon";
import { getProfile } from "./utils/requests/profile";


export const LoadingContext = React.createContext();
export const ThemeContext = React.createContext();
export const CompletionsContext = React.createContext();
export const ContactIdContext = React.createContext();
export const HSPipelineContext = React.createContext();
export const TypesContext = React.createContext();
export const HubspotAccountContext = React.createContext();

function getProfileCacheKey(account, variables) {
  return `hubspot-profile:${variables?.ClientName || "default"}:${account?.homeAccountId || "anonymous"}`;
}

function App({ msalInstance }) {
  const variables = useContext(VariablesContext)


  const [theme, setTheme] = useState(null)
  const [completions, setCompletions] = useState(null);
  const [loading, setLoading] = useState(true);
  const [contactId, setContactId] = useState(null);
  const [hspipelines, setHSPipelines] = useState(null);
  const [types, setTypes] = useState(null);
  const [hubspotAccount, setHubspotAccount] = useState(null);


  useEffect(() => {
    var lastCandidature = localStorage.getItem("lastCandidature");
    if (lastCandidature) {
      localStorage.removeItem("lastCandidature");
    }
    var lastCompletion = lastCandidature ? JSON.parse(lastCandidature) : null;
    var lastCompletionId = lastCompletion ? lastCompletion.objectId : null;
    var lastCompletionObject = lastCompletion ? lastCompletion.objectType : null;
    getAllCompletions(msalInstance, variables, lastCompletionId, lastCompletionObject).then(cand => {
      if (cand) {
        setTypes(cand?.typesParameters ? cand.typesParameters.map(t => { t.selected = false; return t; })?.sort((a, b) => a.order > b.order ? 1 : -1) : []);
        setCompletions(cand.candidatures.filter(c => c !== null));
        setContactId(cand.contactId);
        setLoading(false);
      }
    }).catch(e => { setLoading(false); });

    fetch("/parameters/theme.json").then(res => {
      if (res.ok) {
        return res.json()
      }
    }
    ).then(them => {
      setTheme(them)
      var link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = "data" + them.favicon.split(";data")[1]
    });

    getPipelines(msalInstance, variables).then(pipelines => { setHSPipelines(pipelines?.results) });
  }, [msalInstance, variables])

  useEffect(() => {
    if (variables && variables.Language && !localStorage.getItem("Language")) {
      i18n.changeLanguage(variables.Language);
    }
  }, [variables]);

  useEffect(() => {
    if (!variables || hubspotAccount) {
      return;
    }
    const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
    const profileCacheKey = getProfileCacheKey(account, variables);
    const cachedProfile = sessionStorage.getItem(profileCacheKey);

    if (cachedProfile) {
      try {
        setHubspotAccount(JSON.parse(cachedProfile));
        return;
      } catch {
        sessionStorage.removeItem(profileCacheKey);
      }
    }

    getProfile(msalInstance, variables).then(profile => {
      const accountData = profile;
      accountData.firstname = accountData.firstname || account?.idTokenClaims?.given_name || "Inconnu";
      accountData.lastname = accountData.lastname || account?.idTokenClaims?.family_name || "";
      if (accountData) {
        sessionStorage.setItem(profileCacheKey, JSON.stringify(accountData));
        setHubspotAccount(accountData);
      }
    }).catch(e => {
      console.error("Failed to get profile:", e);
    });
  }, [msalInstance, variables, hubspotAccount]);

  return <div className="h-screen overflow-hidden">
    <Splasher isLoading={loading} />
    {theme && completions ? <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <Suspense fallback={<LoadingComponent />}>
          <ThemeContext.Provider value={theme}>
            <CompletionsContext.Provider value={[completions, setCompletions]}>
              <ContactIdContext.Provider value={contactId}>
                <HSPipelineContext.Provider value={hspipelines}>
                  <HubspotAccountContext.Provider value={hubspotAccount}>
                    <TypesContext.Provider value={[types, setTypes]}>
                      <LoadingContext.Provider value={[loading, setLoading]}>
                        <div className="h-screen overflow-y-auto">
                          <Router />
                        </div>
                      </LoadingContext.Provider>
                    </TypesContext.Provider>
                  </HubspotAccountContext.Provider>
                </HSPipelineContext.Provider>
              </ContactIdContext.Provider>
            </CompletionsContext.Provider>
          </ThemeContext.Provider>
        </Suspense>
      </BrowserRouter>
    </I18nextProvider> : <PlateformeComingSoon />}
  </div>
}

export default App;



